<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-right">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">Location</span>
        </h5>
      </CCol>
      <div style="clear:both"></div>
      <br />
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
          <CCard class="card-custom-blue">
            <div class="m-1" style="
              border-radius: 24px;
              background: rgba(255, 255, 255, 0.15);  
              display: flex;
              width: 70px;
              padding: 13px;
              flex-direction: column;
              align-items: flex-start;
              gap: 10px;
              height:25px;" >
              <img src="../assets/img/location-white.png" style="width: 16px; top: 18px; position: absolute; left: 20px;"/>
              <label class="custom-12px" style="top: 19px; position: absolute; left: 40px; color: #ffffff"> Office </label>
            </div>
            <img src="../assets/img/check.png" style="width: 25px; top: 12px; position: absolute; right: 15px;"/>
            <label class="custom-14px" style="font-weight: 500; color: #FAFAFA; margin-bottom: 0px;"> Jaydon Franci, 32 East 98th Street, New York, NY 10065 , The United States of America </label>
            <label class="custom-14px" style="font-weight: 500; color: #FAFAFA; margin-bottom: 0px;"> 50400 </label>
            <label class="custom-12px" style="color: #FAFAFA; margin-bottom: 0px;"> +1 2345 678 4321 </label>
            <CButton type="button" class="button-border-blue" style="border-color: #FAFAFA; color: #FAFAFA" block @click="GoToEditAddress()">Edit</CButton>
          </CCard>

          <div class="m-1 ml-3" style="
            border-radius: 24px;
            background: var(--Neutral-Background, #F5F5F5); 
            display: flex;
            width: 70px;
            padding: 13px;
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
            height:25px;" >
            <img src="../assets/img/location-2.png" style="width: 16px; top: 228px; position: absolute; left: 40px;"/>
            <label class="custom-12px custom-font-setting" style="top: 228px; position: absolute; left: 60px;"> Home </label>
          </div>
          <input type="radio" style="width: 25px; top: 228px; position: absolute; right: 35px;" />
          <label class="custom-14px custom-font-setting m-1 ml-3" style="font-weight: 500;"> Jaydon Franci, 12 East 96th Street, New York, NY 10065 , The United States of America </label>
          <label class="custom-12px m-1 ml-3"> +1 2345 678 4321 </label>
          <div class="m-2">
            <CButton type="button" class="button-border-blue-white" block>Edit</CButton>
          </div>
          
          <br /><br /> <br /><br /> <br /><br />
        </div>
      
              
      
      
      
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        GoToEditAddress() {
            this.$router.push("/EditAddress");
          },
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }
  </style>